import { weeklyWorkReportColors, workReportLineStatus } from '../../../../../utils/dataStatus';

/**
 * @typedef  IsVisibleEdit
 * @property {import('../../../reducer/optimisticUIReducer').OptimisticUIState} changedActions
 * @property {boolean} isInspector
 * @property {boolean} rectificaCantidad
 */

/** @param {IsVisibleEdit} */
export const isVisibleEdit = ({ changedActions, isInspector, rectificaCantidad }) => {
  // Is approver and can edit quantity.
  if (!isInspector && rectificaCantidad) return true;

  // Is approver and fixed or returned the quantity
  if (
    !isInspector &&
    (changedActions.statusColors === weeklyWorkReportColors.approver.fixed ||
      changedActions.statusColors === weeklyWorkReportColors.approver.returned)
  ) {
    return true;
  }

  // Is inspector, can rectify, and has not performed actions.
  if (isInspector && rectificaCantidad && !changedActions.inspectionColor) return true;

  // Is inspector and performed actions that left the lower part
  // of the cell with state `inspectorMustAct` or `errorSE`
  if (
    isInspector &&
    (changedActions.inspectionColor === weeklyWorkReportColors.inspector.inspectorMustAct ||
      changedActions.inspectionColor === weeklyWorkReportColors.inspector.errorSE)
  ) {
    return true;
  }

  return false;
};

/**
 * @typedef  IsVisibleReview
 * @property {import('../../../reducer/optimisticUIReducer').OptimisticUIState} changedActions
 * @property {number} estadoEnum
 * @property {boolean} isInspector
 * @property {boolean} rectificaCantidad
 * @property {boolean} revisionExperta
 */

/** @param {IsVisibleReview} */
export const isVisibleReview = ({
  changedActions,
  estadoEnum,
  isInspector,
  rectificaCantidad,
  revisionExperta
}) => {
  // Is approver and the report is in 'sent' state
  // (has quantities loaded and can approve it) and has not yet
  // marked expert review.
  if (
    !isInspector &&
    estadoEnum === workReportLineStatus.enviar &&
    changedActions.inspectionColor !== weeklyWorkReportColors.inspector.revision &&
    !revisionExperta
  ) {
    return true;
  }

  // Is approver, can rectify but has already marked expert review
  if (!isInspector && rectificaCantidad && revisionExperta) return false;

  // Is approver and can rectify quantity but has not yet
  // performed any action that affects the lower part of
  // the cell (fix quantity)
  if (!isInspector && rectificaCantidad && !changedActions.inspectionColor) return true;

  // Is inspector, can rectify, has marked expert review, and has not yet
  // taken actions that affect the lower part of the cell (rectify, authorize,
  // reject, or unmark review)
  if (isInspector && rectificaCantidad && revisionExperta && !changedActions.inspectionColor) {
    return true;
  }

  return false;
};
